import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { listOfflineLessons, deleteOfflineLesson } from '../utils/offlineLessons';

export default function OfflineDownloadsCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [lessons, setLessons] = useState(null);

  const load = useCallback(() => {
    listOfflineLessons().then(setLessons);
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!Capacitor.isNativePlatform() || lessons === null) return null;

  const handleRemove = async (lessonId) => {
    await deleteOfflineLesson(lessonId);
    load();
  };

  return (
    <div className="mt-6 bg-white rounded-xl shadow-md p-6">
      <h2 className="text-lg font-bold text-gray-800 mb-1">{t('Offline Downloads')}</h2>
      <p className="text-sm text-gray-500 mb-4">{t('Lessons saved on this device for offline reading.')}</p>

      {lessons.length === 0 ? (
        <p className="text-sm text-gray-400">{t('No lessons downloaded yet.')}</p>
      ) : (
        <div className="space-y-2">
          {lessons.map((cached) => (
            <div key={cached.lesson.id} className="flex items-center justify-between border border-gray-100 rounded-lg px-3 py-2">
              <button
                onClick={() => navigate(`/modules/${cached.moduleId}/lessons/${cached.lesson.id}`)}
                className="text-sm font-medium text-gray-800 hover:text-primary-600 truncate text-left"
              >
                {cached.lesson.title}
              </button>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-xs text-gray-400">{new Date(cached.savedAt).toLocaleDateString()}</span>
                <button onClick={() => handleRemove(cached.lesson.id)} className="text-gray-300 hover:text-red-500" title={t('Delete')}>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
